var _excluded = ["color"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { styled, forwardRef } from '@grupoboticario/flora-react-system';
import { filterUndefined } from '@grupoboticario/flora-react-utils';
var DEFAULT_TAG = 'span';
export var StyledText = styled(DEFAULT_TAG, {
  fontFamily: '$secondary',
  '& > strong': {
    fontWeight: '$strong'
  },
  variants: {
    isTruncated: {
      true: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
      }
    },
    size: {
      displayDeskRegular: {
        fontSize: '$displayDesk',
        lineHeight: '78px'
      },
      displayDeskMedium: {
        fontSize: '$displayDesk',
        lineHeight: '78px'
      },
      displayDeskBold: {
        fontSize: '$displayDesk',
        lineHeight: '78px'
      },
      displayMobileRegular: {
        fontSize: '$displayMobile',
        lineHeight: '64px'
      },
      displayMobileMedium: {
        fontSize: '$displayMobile',
        lineHeight: '64px'
      },
      displayMobileBold: {
        fontSize: '$displayMobile',
        lineHeight: '64px'
      },
      headingDeskRegular: {
        fontSize: '$headingDesk',
        lineHeight: '50px'
      },
      headingDeskMedium: {
        fontSize: '$headingDesk',
        lineHeight: '50px'
      },
      headingDeskBold: {
        fontSize: '$headingDesk',
        lineHeight: '50px'
      },
      headingMobileRegular: {
        fontSize: '$headingMobile',
        lineHeight: '46px'
      },
      headingMobileMedium: {
        fontSize: '$headingMobile',
        lineHeight: '46px'
      },
      headingMobileBold: {
        fontSize: '$headingMobile',
        lineHeight: '46px'
      },
      titleDeskRegular: {
        fontSize: '$titleDesk',
        lineHeight: '40px'
      },
      titleDeskMedium: {
        fontSize: '$titleDesk',
        lineHeight: '40px'
      },
      titleDeskBold: {
        fontSize: '$titleDesk',
        lineHeight: '40px'
      },
      titleMobileRegular: {
        fontSize: '$titleMobile',
        lineHeight: '36px'
      },
      titleMobileMedium: {
        fontSize: '$titleMobile',
        lineHeight: '36px'
      },
      titleMobileBold: {
        fontSize: '$titleMobile',
        lineHeight: '36px'
      },
      subTitleDeskRegular: {
        fontSize: '$subtitleDesk',
        lineHeight: '32px'
      },
      subTitleDeskMedium: {
        fontSize: '$subtitleDesk',
        lineHeight: '32px'
      },
      subTitleDeskBold: {
        fontSize: '$subtitleDesk',
        lineHeight: '32px'
      },
      subTitleMobileRegular: {
        fontSize: '$subtitleMobile',
        lineHeight: '28px'
      },
      subTitleMobileMedium: {
        fontSize: '$subtitleMobile',
        lineHeight: '28px'
      },
      subTitleMobileBold: {
        fontSize: '$subtitleMobile',
        lineHeight: '28px'
      },
      bodyLargeStandardRegular: {
        fontSize: '$bodyLarge',
        lineHeight: '24px'
      },
      bodyLargeStandardMedium: {
        fontSize: '$bodyLarge',
        lineHeight: '24px'
      },
      bodyLargeStandardBold: {
        fontSize: '$bodyLarge',
        lineHeight: '24px'
      },
      bodyLargeStandardSpecialStrikethrough: {
        fontSize: '$bodyLarge',
        lineHeight: '24px'
      },
      bodyLargeStandardSpecialUnderline: {
        fontSize: '$bodyLarge',
        lineHeight: '24px'
      },
      bodyLargeShortRegular: {
        fontSize: '$bodyLarge',
        lineHeight: '20px'
      },
      bodyLargeShortMedium: {
        fontSize: '$bodyLarge',
        lineHeight: '20px'
      },
      bodyLargeShortBold: {
        fontSize: '$bodyLarge',
        lineHeight: '20px'
      },
      bodyLargeShortSpecialStrikethrough: {
        fontSize: '$bodyLarge',
        lineHeight: '20px'
      },
      bodyLargeShortSpecialUnderline: {
        fontSize: '$bodyLarge',
        lineHeight: '20px'
      },
      bodyMediumStandard: {
        fontSize: '$bodySmall',
        //antigos
        lineHeight: '24px'
      },
      bodyMediumShort: {
        fontSize: '$bodySmall',
        //antigos
        lineHeight: '16px'
      },
      bodySmallStandardRegular: {
        fontSize: '$bodySmall',
        lineHeight: '20px'
      },
      bodySmallStandardMedium: {
        fontSize: '$bodySmall',
        lineHeight: '20px'
      },
      bodySmallStandardBold: {
        fontSize: '$bodySmall',
        lineHeight: '20px'
      },
      bodySmallStandardSpecialStrikethrough: {
        fontSize: '$bodySmall',
        lineHeight: '20px'
      },
      bodySmallStandardSpecialUnderline: {
        fontSize: '$bodySmall',
        lineHeight: '20px'
      },
      bodySmallShortRegular: {
        fontSize: '$bodySmall',
        lineHeight: '16px'
      },
      bodySmallShortMedium: {
        fontSize: '$bodySmall',
        lineHeight: '16px'
      },
      bodySmallShortBold: {
        fontSize: '$bodySmall',
        lineHeight: '16px'
      },
      bodySmallShortSpecialStrikethrough: {
        fontSize: '$bodySmall',
        lineHeight: '16px'
      },
      bodySmallShortSpecialUnderline: {
        fontSize: '$bodySmall',
        lineHeight: '16px'
      },
      exceptionsAuxiliarRegular: {
        fontSize: '$auxiliar',
        lineHeight: '16px'
      },
      exceptionsAuxiliarMedium: {
        fontSize: '$auxiliar',
        lineHeight: '16px'
      },
      exceptionsAuxiliarBold: {
        fontSize: '$auxiliar',
        lineHeight: '16px'
      },
      exceptionsAuxiliarSpecialStrikethrough: {
        fontSize: '$auxiliar',
        lineHeight: '16px'
      },
      exceptionsAuxiliarSpecialUnderline: {
        fontSize: '$auxiliar',
        lineHeight: '16px'
      },
      exceptionsRestrictedRegular: {
        fontSize: '$restricted',
        lineHeight: '16px'
      },
      exceptionsRestrictedMedium: {
        fontSize: '$restricted',
        lineHeight: '16px'
      },
      exceptionsRestrictedBold: {
        fontSize: '$restricted',
        lineHeight: '16px'
      },
      exceptionsRestrictedSpecialStrikethrough: {
        fontSize: '$restricted',
        lineHeight: '16px'
      },
      exceptionsRestrictedSpecialUnderline: {
        fontSize: '$restricted',
        lineHeight: '16px'
      },
      auxiliarMini: {
        fontSize: '$restricted',
        lineHeight: '16px'
      }
    },
    variant: {
      primary: {
        fontFamily: '$primary'
      },
      secondary: {
        fontFamily: '$secondary'
      }
    },
    weight: {
      heavy: {
        fontWeight: '$heavy'
      },
      medium: {
        fontWeight: '$medium'
      },
      regular: {
        fontWeight: '$regular'
      },
      light: {
        fontWeight: '$light'
      }
    },
    align: {
      left: {
        textAlign: 'left'
      },
      center: {
        textAlign: 'center'
      },
      right: {
        textAlign: 'right'
      }
    }
  }
});
/**
 * @deprecated Esta tipagem refere-se a um componente que será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link ?path=/docs/core-components-text-deprecated-guia-de-migra%C3%A7%C3%A3o--page| Acesse o guia de migração} para saber como migrar para a nova versão.
 */

/**
 * @deprecated Este componente será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link ?path=/docs/core-components-text-deprecated-guia-de-migra%C3%A7%C3%A3o--page | Acesse o guia de migração} para saber como migrar para a nova versão.
 */
export var Text = forwardRef((_ref, forwardedRef) => {
  var {
    color
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var css = filterUndefined(_extends({
    color
  }, props.css));
  return /*#__PURE__*/React.createElement(StyledText, _extends({}, props, {
    ref: forwardedRef,
    css: css
  }));
});
//# sourceMappingURL=Text.js.map